import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import useRequiredFields from "../../../../hooks/useRequiredFields";
const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [staff, setStaff] = useState([]); // Initialize as empty array instead of object
  const [error, setError] = useState({});
  const [grade, setGrade] = useState([]); // Initialize as empty array
  const [designation, setDesignation] = useState([]); // Initialize as empty array
  const [loading, setLoading] = useState(false);
   const { checkRequiredFields } = useRequiredFields();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await Http.get("/grade");
        console.log("Grade data:", res.data); // Debug log
        setGrade(res.data || []); // Ensure it's an array

        const resDes = await Http.get("/designation");
        console.log("Designation data:", resDes.data); // Debug log
        setDesignation(resDes.data || []); // Ensure it's an array
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const staffChange = (e, index) => {
    const { name, value } = e.target;
    const inputInfo = [...staff];
    inputInfo[index][name] = value;
    setStaff(inputInfo);
  };

  const typeChange = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));

    console.log("Type selected:", value); // Debug log

    const staffArray = [];
    setLoading(true);

    try {
      let response;
      switch (value) {
        case "others":
          response = await Http.get("/staff?status=active");
          break;
        case "increment":
          response = await Http.get("/staff?status=active&apa=increment");
          break;
        case "promotion":
          response = await Http.get("/staff?status=active&apa=promotion");
          break;
        case "upgradation":
          response = await Http.get("/staff?status=active&apa=upgradation");
          break;
        default:
          setLoading(false);
          return;
      }

      console.log("API Response:", response.data); // Debug log

      // Check if response.data is an array
      if (!Array.isArray(response.data)) {
        console.error("API response is not an array:", response.data);
        setLoading(false);
        return;
      }

      response.data.forEach((d, index) => {
        console.log(`Processing staff ${index}:`, d); // Debug log
        console.log(`Staff show value:`, d.show, typeof d.show); // Debug log

        // For "others" type, show all records
        // For other types, only show records where show is true
        const shouldShow = value === "others" || d.show === true;
        console.log(`Should show this staff:`, shouldShow); // Debug log

        if (shouldShow) {
          staffArray.push({
            id: d.id,
            card_no: d.card_no,
            name: d.name,
            joining_date: d.joining_date,
            designation: d.designation?.name || "N/A", // Safe access
            department: d.department?.name || "N/A", // Safe access
            gross: d.salary_structure_latest?.gross || "0", // Safe access
            effective_date: "",
            basic: "",
            other: "",
            apa_name: "",
            designation_id: "",
          });
        }
      });

      console.log("Final staff array:", staffArray); // Debug log
      setStaff(staffArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const formSubmit = () => {
     if (checkRequiredFields()) {
    inputs.staff = staff;
    Http.post("/apa", inputs)
      .then((res) => {
        navigate("/apa", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create APA</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              New Salary Increment Scale
            </h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <label>
                  Type: <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="type"
                  onChange={typeChange}
                  data-required
                >
                  <option value="">Select Type</option>
                  <option value="others">Others (Tk.)</option>
                  <option value="increment">Annual Increment (Qty.)</option>
                  <option value="promotion">Promotion</option>
                  <option value="upgradation">Upgradation</option>
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Remarks <i className="fa fa-star required"></i>
                </label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks || ""}
                  onChange={handleChange}
                  placeholder="Remarks"
                  data-required
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12">
                {/* Debug information */}
                {/* <div
                  style={{
                    marginBottom: "10px",
                    padding: "10px",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  <strong>Debug Info:</strong>
                  <br />
                  Selected Type: {inputs.type || "None"}
                  <br />
                  Staff Array Length:{" "}
                  {Array.isArray(staff) ? staff.length : "Not an array"}
                  <br />
                  Loading: {loading ? "Yes" : "No"}
                </div> */}

                <div className="table-responsive p-0 pb-2">
                  <table className="table container _datatable">
                    <thead>
                      <tr>
                        <th scope="col">Sl</th>
                        <th scope="col">Card No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Joining Date</th>
                        <th scope="col">Designation</th>
                        <th scope="col">Department</th>
                        <th scope="col" style={{ textAlign: "right" }}>
                          Current Salary
                        </th>
                        <th scope="col">Effective Date</th>
                        {inputs.type !== "promotion" &&
                        inputs.type !== "upgradation" ? (
                          <th scope="col">Basic</th>
                        ) : null}
                        {inputs.type !== "promotion" &&
                        inputs.type !== "upgradation" ? (
                          <th scope="col">Other</th>
                        ) : null}
                        {inputs.type === "promotion" ||
                        inputs.type === "upgradation" ? (
                          <th scope="col">Grade</th>
                        ) : null}
                        {inputs.type === "promotion" ||
                        inputs.type === "upgradation" ? (
                          <th scope="col">Designation</th>
                        ) : null}
                        {inputs.type === "others" ? (
                          <th scope="col">APA Name</th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="100%" style={{ textAlign: "center" }}>
                            <ProgressSpinner />
                          </td>
                        </tr>
                      ) : Array.isArray(staff) && staff.length > 0 ? (
                        staff.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>{index + 1}</td>
                            <td>{item.card_no}</td>
                            <td>{item.name}</td>
                            <td>{item.joining_date}</td>
                            <td>{item.designation}</td>
                            <td>{item.department}</td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(item.gross || 0).toFixed(2)}
                            </td>
                            <td>
                              <input
                                type="date"
                                className="form-control"
                                name="effective_date"
                                onChange={(e) => staffChange(e, index)}
                                value={item.effective_date || ""}
                              />
                            </td>
                            {inputs.type !== "promotion" &&
                            inputs.type !== "upgradation" ? (
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="basic"
                                  onChange={(e) => staffChange(e, index)}
                                  value={item.basic || ""}
                                />
                              </td>
                            ) : null}
                            {inputs.type !== "promotion" &&
                            inputs.type !== "upgradation" ? (
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="other"
                                  onChange={(e) => staffChange(e, index)}
                                  value={item.other || ""}
                                />
                              </td>
                            ) : null}
                            {inputs.type === "promotion" ||
                            inputs.type === "upgradation" ? (
                              <td>
                                <select
                                  className="form-control"
                                  name="grade_id"
                                  onChange={(e) => staffChange(e, index)}
                                  value={item.grade_id || ""}
                                >
                                  <option value="">Select Grade</option>
                                  {Array.isArray(grade) &&
                                    grade.map((gradeItem) => (
                                      <option
                                        value={gradeItem.id}
                                        key={gradeItem.id}
                                      >
                                        {gradeItem.name}
                                      </option>
                                    ))}
                                </select>
                              </td>
                            ) : null}
                            {inputs.type === "promotion" ||
                            inputs.type === "upgradation" ? (
                              <td>
                                <select
                                  className="form-control"
                                  name="designation_id"
                                  onChange={(e) => staffChange(e, index)}
                                  value={item.designation_id || ""}
                                >
                                  <option value="">Select Designation</option>
                                  {Array.isArray(designation) &&
                                    designation.map((desItem) => (
                                      <option
                                        value={desItem.id}
                                        key={desItem.id}
                                      >
                                        {desItem.name}
                                      </option>
                                    ))}
                                </select>
                              </td>
                            ) : null}
                            {inputs.type === "others" ? (
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="apa_name"
                                  onChange={(e) => staffChange(e, index)}
                                  value={item.apa_name || ""}
                                />
                              </td>
                            ) : null}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="100%"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            {inputs.type
                              ? "No staff data available"
                              : "Please select a type to view staff"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-3">
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-send mg-r-10"></i> Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
